import { CaretRight } from '@phosphor-icons/react';
import { NavLink } from 'react-router-dom';

interface MainMenuItemProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
  href: string;
  onClick?: () => void;
  collapsed?: boolean;
}

const style = {
  wrapper: (collapsed: boolean) =>
    `group flex items-center rounded-4xl gap-3 ${collapsed ? 'justify-center w-full px-2' : 'px-4'} py-2 text-base font-light text-white! transition-all! duration-300! hover:bg-white/3!`,
  icon: 'block opacity-50 leading-0 group-hover:text-primary group-hover:opacity-100',
  activeIcon: 'text-primary opacity-100',
  rightIcon:
    'text-white group-hover:opacity-20 transition-opacity duration-300',
};

export const MainMenuItem = ({
  href,
  icon,
  children,
  onClick,
  collapsed = false
}: MainMenuItemProps) => {
  return (
    <NavLink
      to={href}
      className={({ isActive }) =>
        isActive ? `${style.wrapper(collapsed)} bg-white/3!` : style.wrapper(collapsed)
      }
      onClick={onClick}
    >
      {({ isActive }) => (
        <>
          <span className={`${style.icon} ${isActive ? style.activeIcon : ''}`}>
            {icon}
          </span>
          {!collapsed && <span className="flex-1">{children}</span>}
          {!collapsed && (
            <i
              className={`${style.rightIcon} ${isActive ? 'opacity-20' : 'opacity-0'
                }`}
            >
              <CaretRight size={16} />
            </i>
          )}
        </>
      )}
    </NavLink>
  );
};
